"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ErrorApi = require("./../../../../utils/ErrorApi");

var _ErrorApi2 = _interopRequireDefault(_ErrorApi);

var _Fetch = require("./../../../../utils/Fetch");

var _Fetch2 = _interopRequireDefault(_Fetch);

var _ParamsFetch = require("./../../../../utils/ParamsFetch");

var _ParamsFetch2 = _interopRequireDefault(_ParamsFetch);

var _JsonFetch = require("./../../../../utils/JsonFetch");

var _JsonFetch2 = _interopRequireDefault(_JsonFetch);

var _generateUrl = require("./../../../../utils/generateUrl");

var _generateUrl2 = _interopRequireDefault(_generateUrl);

var _UpdateMethods = require("./../UpdateMethods");

var UpdateMethods = _interopRequireWildcard(_UpdateMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Rozhraní pro přístup k organizačním jednotkám. @author <a href="mailto:matej.fantis@marbes.cz">Matěj Fantiš</a> @since 18.12.2018 Generated from cz.marbes.api.organizace.v1.OrganizacniJednotkaService.
 */
// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:15:49Z                      #

// ##############################################################

var OrganizacniJednotkaApi = function () {
  function OrganizacniJednotkaApi() {
    (0, _classCallCheck3.default)(this, OrganizacniJednotkaApi);
  }

  (0, _createClass3.default)(OrganizacniJednotkaApi, null, [{
    key: "getOrganizacniJednotky",

    /**
     * Vrátí seznam všech organizačních jednotek @return seznam organizačních jednotek
     *
     * @return java.util.List<cz.marbes.api.organizace.v1.OrganizacniJednotka>
     */
    value: function getOrganizacniJednotky() {
      var uri = serverContextPath + "/api/organizace/v1/organizacnijednotky";
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí organizační jednotku s daným kódem @param kod kód organizační jednotky @return organizační jednotka @throws ObjectNotFoundException organizační jednotka s daným kódem nenalezena
     *
     * @param kod 
     * @return cz.marbes.api.organizace.v1.OrganizacniJednotka
     */

  }, {
    key: "getOrganizacniJednotkaByKod",
    value: function getOrganizacniJednotkaByKod(kod) {
      var uri = serverContextPath + ("/api/organizace/v1/organizacnijednotky/" + kod);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }

    /**
     * Vrátí organizační jednotku s daným ID @param id ID organizační jednotky @return organizační jednotka @throws ObjectNotFoundException organizační jednotka s daným ID nenalezena
     *
     * @param id 
     * @return cz.marbes.api.organizace.v1.OrganizacniJednotka
     */

  }, {
    key: "getOrganizacniJednotkaById",
    value: function getOrganizacniJednotkaById(id) {
      var uri = serverContextPath + ("/api/organizace/v1/organizacnijednotky/" + id);
      var headers = undefined;
      var params = {};

      return _ErrorApi2.default.responseResolver(_JsonFetch2.default.get(uri, params, headers));
    }
  }]);
  return OrganizacniJednotkaApi;
}();

exports.default = OrganizacniJednotkaApi;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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